/**
 * 菜单工具函数
 * 用于处理菜单相关的工具方法
 */

import { MenuItem } from '../types/menu';

/**
 * 从菜单树中递归查找第一个有路径的菜单项（叶子节点）
 * @param menus 菜单列表
 * @returns 第一个有路径的菜单项，如果没有则返回null
 */
export const findFirstMenuPath = (menus: MenuItem[]): string | null => {
  if (!menus || menus.length === 0) {
    return null;
  }

  // 按orderNum排序，确保按顺序查找
  const sortedMenus = [...menus].sort((a, b) => (a.orderNum || 0) - (b.orderNum || 0));

  for (const menu of sortedMenus) {
    // 如果是叶子节点（没有子菜单）且有路径，返回该路径
    if ((!menu.children || menu.children.length === 0) && menu.path) {
      // 确保路径是有效的（不为空且以/开头）
      const path = menu.path.trim();
      if (path && path.startsWith('/')) {
        return path;
      }
    }

    // 如果有子菜单，递归查找
    if (menu.children && menu.children.length > 0) {
      const childPath = findFirstMenuPath(menu.children);
      if (childPath) {
        return childPath;
      }
    }
  }

  return null;
};

/**
 * 检查当前路径是否在用户的菜单权限中
 * @param currentPath 当前路径
 * @param menus 用户菜单列表
 * @returns 是否在菜单权限中
 */
export const isPathInMenus = (currentPath: string, menus: MenuItem[]): boolean => {
  if (!menus || menus.length === 0) {
    return false;
  }

  // 标准化路径（去掉尾部斜杠）
  const normalizePath = (path: string) => {
    if (!path) return '';
    return path.replace(/\/$/, '') || '/';
  };

  const normalizedCurrentPath = normalizePath(currentPath);

  // 递归检查菜单路径
  const checkMenu = (menuList: MenuItem[]): boolean => {
    for (const menu of menuList) {
      const menuPath = normalizePath(menu.path || '');
      
      // 检查路径是否完全匹配
      if (menuPath && normalizedCurrentPath === menuPath) {
        return true;
      }

      // 检查子菜单
      if (menu.children && menu.children.length > 0) {
        if (checkMenu(menu.children)) {
          return true;
        }
      }
    }
    return false;
  };

  return checkMenu(menus);
};







